import { render, staticRenderFns } from "./ChemicalIndustry.vue?vue&type=template&id=50c0e692&scoped=true"
import script from "./ChemicalIndustry.vue?vue&type=script&lang=js"
export * from "./ChemicalIndustry.vue?vue&type=script&lang=js"
import style0 from "./ChemicalIndustry.vue?vue&type=style&index=0&id=50c0e692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c0e692",
  null
  
)

export default component.exports